import PublicNav from "@/components/PublicNav";
import PublicFooter from "@/components/PublicFooter";

function Body({ children }) {
  return <p className="k-muted" style={{ fontSize: 16, marginTop: 16, lineHeight: 1.65, whiteSpace: "pre-line" }}>{children}</p>;
}

export default function About() {
  return (
    <div className="k-canvas">
      <PublicNav />
      <section style={{ margin: "0 auto", padding: "64px 24px 24px" }} data-testid="about-page">
        <h1 className="k-heading" data-testid="about-h1"
          style={{ fontSize: "clamp(36px,5vw,56px)", letterSpacing: "-.03em", margin: 0 }}>
          Why Kadana exists
        </h1>
        <p className="k-muted" data-testid="about-subhead" style={{ fontSize: 20, marginTop: 24, lineHeight: 1.55 }}>
          Most AI app builders assume a universal stack — Stripe, a Silicon Valley privacy banner, Western business
          norms baked into every decision. That works for a generic SaaS aimed at US or UK consumers. It breaks the
          moment a business operates under different rules.
        </p>
      </section>

      <section style={{ margin: "0 auto", padding: "20px 24px" }} data-testid="about-gap">
        <h2 className="k-heading" style={{ fontSize: 22, marginBottom: 4 }}>The gap</h2>
        <Body>{`A housing platform in Poland needs ePUAP digital identity and KSeF structured e-invoicing to be usable at all — without them, it is not just incomplete, it is not legally usable. An agricultural or micro-lending platform in Kenya needs M-Pesa, not a card form built for a different market. Many European, Middle Eastern and African businesses cannot legally host their residents' data on a US-centric managed cloud at all.

Generalist AI builders produce a slick interface quickly. As the regulatory edge cases, the local payment rails and the multi-tenant logic compound, that speed runs out — these are exactly the details a generic build has no reason to get right the first time.

Kadana treats regional law, local payment rails and data residency as part of the build from the first prompt, not something bolted on afterwards. We're not just another app builder: we're building toward the infrastructure layer that lets AI-generated software actually operate, legally and locally, everywhere it's used.`}</Body>
      </section>

      <section style={{ margin: "0 auto", padding: "20px 24px" }} data-testid="about-history">
        <h2 className="k-heading" style={{ fontSize: 22, marginBottom: 4 }}>How we got here</h2>
        <Body>{`Kadana started almost entirely by accident — as the best things often are.

After a 20-year career in banking, our founder began a PhD in Behavioural Economics in his 40s, driven by a lasting curiosity about how people actually relate to money. He followed it with a second PhD, in Computer Science, choosing rural Kenya as his fieldwork — studying Chamas, the community savings groups that keep much of rural Kenyan finance running.

The goal was simple: help the women running these Chamas automate the manual, error-prone parts of their record-keeping. It didn't work. Traditional software development was too slow and too expensive for the problem, and the no-code tools that existed were built for Silicon Valley, not for community finance in rural Kenya. So he started teaching younger Chama members to build the tools their own parents needed.

That's when the real idea arrived: genuine economic empowerment means democratising who gets to build software, not just who gets to use it. He stepped away from the PhD to build that properly — an agentic, hyper-localised app-building platform, starting in the UK, where a rural Chama member and a UK business owner can each build real, compliance-ready software without writing a line of code.`}</Body>
      </section>

      <PublicFooter />
    </div>
  );
}
